import { reducers } from 'redux/core'
import request from 'sb-request'
import { getGqlQuery, constants } from 'common/helpers'


const fetch = () => {
  reducers.models.productSets.setFetching(true)

  const input = {
    groups: 'ProductSet',
    visibility: [
      constants.productVisibility.invisible,
      constants.productVisibility.visible,
    ],
  }

  return request.post('graphql?name=productSets', {
    body: {
      query: `{
        ${getGqlQuery('products', input)} {
          id
          name
          image
          description
          imgMobile: imageMobile
          imgDesktop: imageHq
          price
          tradingItem {
            id
            price
            priceWithDiscount
          }
          productSetItems {
            id
            url
            name
            brand
            image
            description
            rating
            labels
            notes {
              id
              name
              slug
              image
            }
          }
        }
      }`,
    },
    modifyResult: ({ products = [] }) => products.map((productSet) => ({
      ...productSet,
      tradingItemId: productSet.tradingItem.id,
      price: productSet.tradingItem.priceWithDiscount,
      oldPrice: productSet.tradingItem.price,
    })),
  })
    .then(
      (products) => {
        reducers.models.productSets.setItems(products)

        return products
      },
      () => {
        reducers.models.productSets.setItems([])
        reducers.models.productSets.setFetching(false)
        return Promise.reject()
      }
    )
}


export default {
  fetch,
}
